import { useCallback, useEffect } from 'react';
import {
  useGetUserQuery,
  useLazyGetNPSDataQuery,
} from '~/redux/api/userApiSlice';

declare global {
  interface Window {
    wootricSettings?: {
      email?: string | null;
      created_at?: number | null;
      account_token: string;
      language?: { code: string };
      properties?: Record<string, string | number | boolean | null>;
    };
    wootric?: (action: 'run') => void;
    wootric_survey_immediately?: boolean;
  }
}

type Props = {
  locale: string;
};

export default function Wootric({ locale }: Props) {
  const { data: userData } = useGetUserQuery();
  const [getNPSData] = useLazyGetNPSDataQuery();

  const initWootricSettings = useCallback(async () => {
    const data = await getNPSData().unwrap();
    const createdAtDate = data.createdAt ? new Date(data.createdAt) : null;
    const createdAtUnix = createdAtDate?.getTime()
      ? createdAtDate.getTime() / 1000
      : null;
    (window as any).wootricSettings = {
      email: data.userEmail || null,
      created_at: createdAtUnix,
      account_token: data.wootric_account_token,
      language: { code: locale },
      properties: data.properties ?? {},
    };
    window.wootric?.('run');
  }, [getNPSData, locale]);

  useEffect(() => {
    if (!userData || typeof window === 'undefined') return;
    initWootricSettings();
  }, [userData, initWootricSettings]);

  return null;
}
